/* Progressive enhancements for the Kutta storefront. Native Shopify forms remain functional. */
(() => {
  'use strict';
  if (window.__kuttaLoaded) return;
  window.__kuttaLoaded = true;
  const cfg = {}, str = {};
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  // Read configuration when needed; Shopify can load inline settings after this file.
  const fallbackStrings = {
    it: {add:'Aggiungi al carrello',soldOut:'Esaurito',available:'Disponibile',unavailable:'Al momento non disponibile',error:'Non è stato possibile aggiornare il carrello. Riprova.',added:'Prodotto aggiunto al carrello',loading:'Caricamento…'},
    de: {add:'In den Warenkorb',soldOut:'Ausverkauft',available:'Verfügbar',unavailable:'Aktuell nicht verfügbar',error:'Der Warenkorb konnte nicht aktualisiert werden. Bitte versuche es erneut.',added:'Produkt zum Warenkorb hinzugefügt',loading:'Wird geladen…'},
    en: {add:'Add to cart',soldOut:'Sold out',available:'Available',unavailable:'Currently unavailable',error:'The cart could not be updated. Please try again.',added:'Product added to cart',loading:'Loading…'},
    fr: {add:'Ajouter au panier',soldOut:'Épuisé',available:'Disponible',unavailable:'Actuellement indisponible',error:'Le panier n’a pas pu être mis à jour. Veuillez réessayer.',added:'Produit ajouté au panier',loading:'Chargement…'},
    es: {add:'Añadir al carrito',soldOut:'Agotado',available:'Disponible',unavailable:'Actualmente no disponible',error:'No se ha podido actualizar el carrito. Inténtalo de nuevo.',added:'Producto añadido al carrito',loading:'Cargando…'}
  };
  const localUrl = value => {
    if (typeof value !== 'string' || !value.trim()) return null;
    try {
      const url = new URL(value, location.origin);
      return url.origin === location.origin ? url : null;
    } catch { return null; }
  };
  const resolveRoute = (action, candidates, fallback) => {
    const suffix = action ? `/cart/${action}` : '/cart';
    for (const candidate of [...candidates, fallback]) {
      const url = localUrl(candidate);
      if (!url) continue;
      const path = url.pathname.replace(/\/+$/, '').replace(/\.js$/, '');
      if (!path.endsWith(suffix)) continue;
      return path + url.search;
    }
    return suffix;
  };
  const refreshConfig = form => {
    const current = window.Kutta || {}, routes = window.routes || {};
    const root = localUrl(window.Shopify?.routes?.root) || localUrl(current.root);
    const rootPath = root ? root.pathname.replace(/\/*$/, '/') : '/';
    cfg.cartUrl = resolveRoute('', [current.cartUrl, routes.cart_url, root ? `${rootPath}cart` : null, $('[data-k-cart]')?.getAttribute('href')], `${rootPath}cart`);
    const cartPath = new URL(cfg.cartUrl, location.origin).pathname;
    cfg.addUrl = resolveRoute('add', [form?.getAttribute('action'), current.addUrl, routes.cart_add_url], `${cartPath}/add`);
    cfg.changeUrl = resolveRoute('change', [current.changeUrl, routes.cart_change_url], `${cartPath}/change`);
    cfg.updateUrl = resolveRoute('update', [current.updateUrl, routes.cart_update_url], `${cartPath}/update`);
    cfg.drawer = typeof current.drawer === 'boolean' ? current.drawer : !!$('#KuttaCart');
    const lang = document.documentElement.lang.toLowerCase().split('-')[0];
    Object.assign(str, fallbackStrings[lang] || fallbackStrings.en);
    for (const [key,value] of Object.entries(current.strings || {})) {
      if (typeof value === 'string' && value.trim()) str[key] = value;
    }
  };
  const jsonUrl = url => {
    const parsed = localUrl(url);
    if (!parsed) throw new Error(str.error);
    parsed.pathname = parsed.pathname.replace(/\/+$/, '').replace(/\.js$/, '') + '.js';
    return parsed.pathname + parsed.search;
  };
  refreshConfig();
  let returnFocus, cartBusy = false, queuedCartChanges = new Map();
  const status = (s) => { const el = $('[data-k-status]'); if (el) el.textContent = s; };
  const openDialog = (dialog, trigger) => {
    if (!dialog || !dialog.showModal) return false;
    $$('dialog[open]').forEach(d => { if (d !== dialog) d.close(); });
    returnFocus = trigger || document.activeElement;
    if (trigger) trigger.setAttribute('aria-expanded', 'true');
    if (!dialog.open) dialog.showModal();
    document.documentElement.style.overflow = 'hidden';
    const input = $('input[type=search]', dialog); if (input) input.focus();
    return true;
  };
  document.addEventListener('close', (e) => {
    if (!(e.target instanceof HTMLDialogElement)) return;
    if (!$('dialog[open]')) document.documentElement.style.overflow = '';
    $$('[data-k-open][aria-expanded=true]').forEach(t => t.setAttribute('aria-expanded', 'false'));
    if (returnFocus?.isConnected) returnFocus.focus({preventScroll:true});
  }, true);
  const displayError = (form, message) => {
    let el = $('.k-form-error, .k-cart-error', form);
    if (!el) { el = document.createElement('p'); el.className='k-form-error';el.setAttribute('role','alert');form.append(el); }
    el.textContent = message || str.error; el.hidden = false;
  };
  const parseResponse = async response => {
    let body; try { body = await response.json(); } catch { throw new Error(str.error); }
    if (!response.ok || body.status >= 400) {
      const msg = typeof body.description === 'string' ? body.description : typeof body.message === 'string' ? body.message : str.error;
      throw new Error(msg);
    }
    return body;
  };
  const renderCart = html => {
    if (!html) return false;
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const content = $('[data-k-cart-content]', doc);
    if (!content) return false;
    const mount = $('[data-k-cart-mount]');
    if (mount) mount.replaceChildren((content.closest('#shopify-section-kutta-cart-content') || content).cloneNode(true));
    const pageMount = $('.k-cart-page [data-k-cart-content]');
    if (pageMount) {
      const pageContent=content.cloneNode(true);
      $$('[id]',pageContent).forEach(el=>el.setAttribute('id',(el.getAttribute('id')||'').replace('-drawer','-page')));
      $$('label[for]',pageContent).forEach(el=>el.setAttribute('for',(el.getAttribute('for')||'').replace('-drawer','-page')));
      pageMount.replaceWith(pageContent);
    }
    $$('[data-k-cart-count]').forEach(el => el.textContent = content.dataset.count || '0');
    return true;
  };
  const loadCart = async () => {
    refreshConfig();
    const sectionUrl = new URL(cfg.cartUrl, location.origin);
    sectionUrl.searchParams.set('section_id','kutta-cart-content');
    const response=await fetch(sectionUrl.pathname + sectionUrl.search,{credentials:'same-origin',headers:{'Accept':'text/html'}});
    if(!response.ok) throw new Error(str.error);
    if(!renderCart(await response.text())) throw new Error(str.error);
  };
  // Adapter used by the original theme's product-form component.
  window.KuttaCart = {
    getSectionsToRender: () => [{id:'kutta-cart-content'}],
    setActiveElement: element => { returnFocus = element; },
    getAddUrl: form => { refreshConfig(form); return jsonUrl(cfg.addUrl); },
    getCartUrl: () => { refreshConfig(); return cfg.cartUrl; },
    async renderContents(response) {
      refreshConfig();
      status(str.added);
      const dialog = $('#KuttaCart');
      if (!cfg.drawer || !dialog?.showModal) { location.assign(cfg.cartUrl); return; }
      try {
        if (!renderCart(response.sections?.['kutta-cart-content'])) await loadCart();
        openDialog(dialog, returnFocus);
      } catch { location.assign(cfg.cartUrl); }
    }
  };
  const addToCart = async form => {
    // Product cards use the same route resolver as the native product form.
    refreshConfig(form);
    if (form.dataset.busy) return;
    if (!form.reportValidity()) return;
    const submit = $('button[type=submit]', form), err=$('.k-form-error',form);
    if(err)err.hidden=true;
    form.dataset.busy='true';form.setAttribute('aria-busy','true');
    if(submit){submit.disabled=true;submit.setAttribute('aria-busy','true');}
    try {
      const data=new FormData(form);data.append('sections','kutta-cart-content');data.append('sections_url',location.pathname);
      const result=await parseResponse(await fetch(jsonUrl(cfg.addUrl),{method:'POST',body:data,credentials:'same-origin',headers:{'Accept':'application/json'}}));
      status(str.added);
      if(cfg.drawer && $('#KuttaCart')?.showModal){
        try {
          if(!renderCart(result.sections?.['kutta-cart-content']))await loadCart();
          openDialog($('#KuttaCart'),submit);
        } catch { location.assign(cfg.cartUrl); }
      } else location.assign(cfg.cartUrl);
    } catch(e) {displayError(form,e.message);}
    finally {delete form.dataset.busy;form.removeAttribute('aria-busy');if(submit){submit.disabled=false;submit.removeAttribute('aria-busy');}const product=form.closest('[data-k-product]');if(product)syncProduct(product);}
  };
  const changeCart = async (key, quantity) => {
    refreshConfig();
    queuedCartChanges.set(key, quantity);
    if(cartBusy)return;
    cartBusy=true;
    let failure;
    try {
      while(queuedCartChanges.size){
        const [lineKey,qty]=queuedCartChanges.entries().next().value;queuedCartChanges.delete(lineKey);
        $$('.k-cart-form').forEach(f=>f.setAttribute('aria-busy','true'));
        try {
          const result=await parseResponse(await fetch(jsonUrl(cfg.changeUrl),{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({id:lineKey,quantity:qty,sections:['kutta-cart-content'],sections_url:location.pathname})}));
          if(!renderCart(result.sections?.['kutta-cart-content']))await loadCart();
        }catch(e){failure=e.message;queuedCartChanges.clear();try{await loadCart();}catch{}break;}
      }
    } finally {
      cartBusy=false;$$('.k-cart-form').forEach(f=>{f.removeAttribute('aria-busy');if(failure)displayError(f,failure);});
    }
  };
  const showMedia=(root,id)=>{
    const slides=$$('[data-media-id]',root),chosen=slides.find(slide=>slide.dataset.mediaId===String(id));
    if(!chosen)return;
    slides.forEach(slide=>{const active=slide===chosen;slide.hidden=!active;if(!active)$$('video',slide).forEach(v=>v.pause());});
    $$('[data-k-media]',root).forEach(button=>button.setAttribute('aria-pressed',String(button.dataset.kMedia===String(id))));
    const count=$('[data-k-gallery-count]',root);if(count)count.textContent=`${slides.indexOf(chosen)+1} / ${slides.length}`;
  };
  const syncProduct=root=>{
    refreshConfig();
    const select=$('[name=id]',root),data=$('[data-k-variants]',root);if(!select||!data)return;
    let variants;try{variants=JSON.parse(data.textContent);}catch{return;}
    const variant=variants.find(v=>String(v.id)===String(select.value));if(!variant)return;
    const wrap=$('[data-k-price-wrap]',root);
    if(wrap){
      const price=document.createElement('div');price.className='k-price';price.dataset.kPrice='';
      const current=document.createElement('span');current.className='k-price-current';current.textContent=variant.price;price.append(current);
      if(variant.compare>variant.priceNumber){const compare=document.createElement('s');compare.className='k-price-compare';compare.textContent=variant.compareText;price.append(compare);const sale=document.createElement('span');sale.className='k-sale';sale.textContent=`−${Math.round((variant.compare-variant.priceNumber)*100/variant.compare)}%`;price.append(sale);}
      wrap.replaceChildren(price);
      if(variant.unit){const unit=document.createElement('div');unit.className='k-unit-price';unit.textContent=`${variant.unitPrice} / ${variant.unitReference===1?'':variant.unitReference}${variant.unit}`;wrap.append(unit);}
    }
    const form=$('.k-product-form',root),busy=!!form?.dataset.busy;
    $$('[data-k-submit],[data-k-sticky-submit]',root).forEach(button=>button.disabled=!variant.available||busy);
    const label=$('[data-k-submit-label]',root);if(label)label.textContent=variant.available?str.add:str.soldOut;
    const sticky=$('[data-k-sticky-submit]',root);if(sticky)sticky.textContent=variant.available?str.add:str.soldOut;
    const stickyPrice=$('[data-k-sticky-price]',root);if(stickyPrice)stickyPrice.textContent=variant.price;
    const stock=$('[data-k-stock]',root);if(stock){stock.classList.toggle('is-unavailable',!variant.available);stock.lastElementChild.textContent=variant.available?str.available:str.unavailable;}
    const quantity=$('[name=quantity]',root);if(quantity){quantity.min=variant.min;quantity.step=variant.step;if(variant.max)quantity.max=variant.max;else quantity.removeAttribute('max');let next=Math.max(variant.min,Number(quantity.value)||variant.min);next=variant.min+Math.floor((next-variant.min)/variant.step)*variant.step;if(variant.max)next=Math.min(variant.max,next);quantity.value=next;}
    if(variant.media)showMedia(root,variant.media);
  };
  const init=(scope=document)=>{
    refreshConfig();
    $$('[data-k-product]',scope).forEach(root=>{
      if(root.dataset.initialized)return;root.dataset.initialized='true';syncProduct(root);
      const buy=$('[data-k-submit]',root),sticky=$('[data-k-sticky]',root);
      if(buy&&sticky&&'IntersectionObserver' in window){const observer=new IntersectionObserver(entries=>{const entry=entries[0];sticky.hidden=entry.isIntersecting||entry.boundingClientRect.top>0;},{threshold:0});observer.observe(buy);root._kObserver=observer;}
    });
    if(document.body.hasAttribute('data-k-animate')&&!matchMedia('(prefers-reduced-motion: reduce)').matches&&'IntersectionObserver' in window){
      const observer=new IntersectionObserver(entries=>entries.forEach(entry=>{if(entry.isIntersecting){entry.target.classList.add('k-reveal-active');observer.unobserve(entry.target);}}),{threshold:.08});
      $$('.k-need,.k-story,.k-routine',scope).forEach(el=>observer.observe(el));
    }
  };
  document.addEventListener('click', async e=>{
    refreshConfig();
    const close=e.target.closest('[data-k-close]');if(close){close.closest('dialog')?.close();return;}
    const trigger=e.target.closest('[data-k-open]');if(trigger){if(openDialog(document.getElementById(trigger.dataset.kOpen),trigger))e.preventDefault();return;}
    if(e.target instanceof HTMLDialogElement){const rect=e.target.getBoundingClientRect();if(e.clientX<rect.left||e.clientX>rect.right||e.clientY<rect.top||e.clientY>rect.bottom)e.target.close();return;}
    if(e.target.closest('.k-mobile-nav a')){e.target.closest('dialog')?.close();}
    const cart=e.target.closest('[data-k-cart]');if(cart&&cfg.drawer&&$('#KuttaCart')?.showModal){e.preventDefault();cart.setAttribute('aria-busy','true');try{await loadCart();openDialog($('#KuttaCart'),cart);}catch{location.assign(cfg.cartUrl);}finally{cart.removeAttribute('aria-busy');}return;}
    const remove=e.target.closest('[data-k-remove]');if(remove){e.preventDefault();changeCart(remove.dataset.kRemove,0);return;}
    const quantityBtn=e.target.closest('[data-k-plus],[data-k-minus]');if(quantityBtn){const input=$('input[type=number]',quantityBtn.closest('.k-quantity'));if(!input)return;try{if(quantityBtn.hasAttribute('data-k-plus'))input.stepUp();else input.stepDown();}catch{return;}input.dispatchEvent(new Event('change',{bubbles:true}));return;}
    const thumb=e.target.closest('[data-k-media]');if(thumb){showMedia(thumb.closest('[data-k-product]'),thumb.dataset.kMedia);return;}
    const galleryBtn=e.target.closest('[data-k-gallery-next],[data-k-gallery-prev]');if(galleryBtn){const root=galleryBtn.closest('[data-k-product]'),slides=$$('[data-media-id]',root),index=slides.findIndex(s=>!s.hidden),next=(index+(galleryBtn.hasAttribute('data-k-gallery-next')?1:-1)+slides.length)%slides.length;if(slides[next])showMedia(root,slides[next].dataset.mediaId);}
    const outsideDetails=$$('.k-nav-dropdown[open],.k-filter-details[open]');outsideDetails.forEach(detail=>{if(!detail.contains(e.target))detail.open=false;});
  });
  document.addEventListener('submit',e=>{if(e.target.matches('.k-add-form')){e.preventDefault();addToCart(e.target);}});
  document.addEventListener('change',async e=>{
    refreshConfig();
    const input=e.target;
    if(input.matches('[data-k-variant]')){const root=input.closest('[data-k-product]');syncProduct(root);const next=new URL(location.href);next.searchParams.set('variant',input.value);history.replaceState({},'',next);}
    if(input.matches('[data-k-sort]'))input.form.requestSubmit();
    if(input.matches('[data-k-cart-quantity]')){if(!input.reportValidity())return;changeCart(input.dataset.key,parseInt(input.value,10));}
    if(input.matches('[data-k-note]')){
      const form=input.closest('form');const checkout=$('[name=checkout]',form);if(checkout)checkout.disabled=true;
      try{await parseResponse(await fetch(jsonUrl(cfg.updateUrl),{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json'},body:JSON.stringify({note:input.value})}));}catch(e){displayError(form,e.message);}finally{if(checkout)checkout.disabled=false;}
    }
  });
  document.addEventListener('shopify:section:load',e=>init(e.target));
  document.addEventListener('shopify:section:select',e=>{if(e.target.id==='shopify-section-kutta-cart-content')openDialog($('#KuttaCart'));});
  document.addEventListener('shopify:section:unload',e=>{$$('[data-k-product]',e.target).forEach(r=>r._kObserver?.disconnect());});
  document.addEventListener('shopify:block:select',e=>{const detail=e.target.closest('details');if(detail)detail.open=true;});
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(), {once:true});
  } else init();
})();
